var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigninAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12-12h56v56h-56z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#323130",
    fillRule: "nonzero",
    d: "M20.375 20.5h-.114a5.541 5.541 0 0 0-.712-1.81 5.64 5.64 0 0 0-2.887-2.356A5.502 5.502 0 0 0 14.75 16c-.516 0-1.014.067-1.494.202s-.929.324-1.345.567a5.6 5.6 0 0 0-1.138.879 5.6 5.6 0 0 0-1.446 2.483c-.135.48-.202.978-.202 1.494H8c0-.703.104-1.38.312-2.03a6.78 6.78 0 0 1 2.259-3.27 6.517 6.517 0 0 1 1.788-1.01 4.723 4.723 0 0 1-1.55-1.635 4.342 4.342 0 0 1-.559-2.18c0-.621.117-1.206.352-1.753a4.516 4.516 0 0 1 .962-1.433 4.516 4.516 0 0 1 1.433-.962A4.41 4.41 0 0 1 14.75 7a4.41 4.41 0 0 1 1.753.352 4.516 4.516 0 0 1 1.433.962c.407.407.728.885.962 1.433a4.41 4.41 0 0 1 .352 1.753 4.51 4.51 0 0 1-2.11 3.814c.657.252 1.262.6 1.816 1.042a6.828 6.828 0 0 1 1.419 1.542V20.5zm-9-9c0 .469.088.907.264 1.314a3.416 3.416 0 0 0 1.797 1.797 3.28 3.28 0 0 0 1.314.264c.463 0 .9-.088 1.31-.264a3.402 3.402 0 0 0 1.801-1.797 3.28 3.28 0 0 0 .264-1.314c0-.463-.088-.9-.264-1.31A3.402 3.402 0 0 0 16.06 8.39a3.29 3.29 0 0 0-1.31-.264 3.28 3.28 0 0 0-1.314.264 3.416 3.416 0 0 0-1.797 1.801 3.29 3.29 0 0 0-.264 1.31zm11.25 10.125h2.25v1.125h-2.25V25H21.5v-2.25h-2.25v-1.125h2.25v-2.25h1.125v2.25z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "#323130"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninAvatar);
export default __webpack_public_path__ + "static/media/signin_avatar.8b6e1277548efbc3bc727448a46042c5.svg";
export { ForwardRef as ReactComponent };